module.exports = __webpack_public_path__ + "static/media/Skater Girl.0482b5da.jpg";